import * as React from 'react';

interface Props {
  children: any[];
  className: string;
}

export default class ButtonGroup extends React.Component<Props> {
  static defaultProps = {
    className: 'button-group field is-grouped',
  };

  render() {
    return (
      <div className={this.props.className}>
        {this.props.children.map((child, index) => (
          <div key={index} className="control">
            {child}
          </div>
        ))}
      </div>
    );
  }
}
